export class AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "indexName",
            "baseName": "indexName",
            "type": "string",
            "format": ""
        },
        {
            "name": "keySchema",
            "baseName": "keySchema",
            "type": "Array<AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner>",
            "format": ""
        },
        {
            "name": "projection",
            "baseName": "projection",
            "type": "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection",
            "format": ""
        },
        {
            "name": "indexSizeBytes",
            "baseName": "indexSizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner.attributeTypeMap;
    }
    constructor() {
    }
}
